<template>
  <BaseModal
    class="modal_confirm"
    :class="{ modal_clean: isClean }"
    :has-close-button="false"
    :replic="replic"
    v-on="$listeners"
  >
    <BaseTitle
      v-if="title"
      :text="title"
      size="l"
      class="modal__title"
    />
    <template #actions>
      <BaseButton
        :text="agreeText"
        size="xs"
        class="modal__action"
        @click="$emit('agree')"
      />
      <BaseButton
        :text="disagreeText"
        size="xs"
        class="modal__action"
        @click="$emit('disagree')"
      />
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'ModalConfirm',
  components: {
    BaseModal,
    BaseTitle,
    BaseButton,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    replic: {
      type: String,
      default: '',
    },
    agreeText: {
      type: String,
      default() {
        return this.$t('actions.yes');
      },
    },
    disagreeText: {
      type: String,
      default() {
        return this.$t('actions.no');
      },
    },
    isClean: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
